import { forwardRef } from 'react';

import { Paper, type PaperProps } from '..';
import { styled } from '../../../styles';

export const StyledPaperContainer = styled(Paper)({
  // remove overlay that affects dark mode background and lighten the background of the component
  backgroundImage: 'none',
}) as typeof Paper;

/**
 * PaperContainer is the Paper component without the overlay in dark mode.
 *
 * Only use in a flat layout and not on top of another component.
 */
export const PaperContainer = forwardRef<HTMLDivElement, PaperProps>(
  (props: PaperProps, ref) => {
    const { elevation = 0, ...rest } = props;
    return <StyledPaperContainer ref={ref} elevation={elevation} {...rest} />;
  },
);
